import React from 'react'
import { connect } from 'react-redux'
import HeaderTitle from '../Header/HeaderTitle'
import { Grid, Card, AppBar, Tabs, Tab } from '@mui/material'
import StoreDeviceStatuses from './StoreDeviceStatuses/StoreDeviceStatuses'
import ImagesoundPlayers from './ImagesoundPlayers/ImagesoundPlayers'
import { handleFireflySendEvent } from '../Utils/FireFlyVnextHelpers'

export class DeviceStatuses extends React.Component {
  constructor(props) {
    super(props)
    this.availableTabs = [
      {
        name: 'STORE DEVICE STATUSES',
        requiredAdGroups: ['APP-ZIPTIE-ADMIN', 'APP-OAUTH2-ZIPTIE-READ'],
      },
      {
        name: 'IMAGESOUND PLAYERS',
        requiredAdGroups: ['APP-ZIPTIE-ADMIN', 'APP-OAUTH2-ZIPTIE-READ'],
      },
    ]
    this.state = {
      authorizedTabs: [],
      loading: true,
      selectedTab: 0,
    }
    this.handleTabChange = this.handleTabChange.bind(this)
    this.dialogBox = React.createRef()
  }

  async componentDidMount() {
    const { userInfo } = this.props
    if (userInfo.email !== '') {
      handleFireflySendEvent(
        'PAGE_VIEW',
        'Device Status',
        'Device Status Page Load',
        userInfo,
      )
    }
    const authorizedTabs = this.availableTabs.filter(function (tab) {
      return (
        tab.requiredAdGroups.filter((group) =>
          userInfo.memberOf.includes(group),
        ).length > 0 || tab.requiredAdGroups.length === 0
      )
    })
    this.setState({
      authorizedTabs: authorizedTabs,
      loading: false,
      selectedTab: authorizedTabs[0].name,
    })
  }

  handleTabChange(event, newTab) {
    this.setState({
      selectedTab: newTab,
    })
  }

  render() {
    const { classes, userInfo } = this.props

    let tabLabels = []
    this.state.authorizedTabs.forEach((tab) => {
      let tabLabel = <Tab key={tab.name} label={tab.name} value={tab.name} />
      tabLabels.push(tabLabel)
    })

    return (
      <div>
        <HeaderTitle title="Device Status" />
        <Grid item size={{ xs: 12 }}>
          <Card style={{ height: '80vh' }}>
            <AppBar position="static">
              <Tabs
                value={this.state.selectedTab}
                onChange={this.handleTabChange}
                variant="scrollable"
                scrollButtons="auto"
              >
                {tabLabels}
              </Tabs>
            </AppBar>
            {this.state.selectedTab === 'STORE DEVICE STATUSES' &&
              (userInfo.memberOf.includes('APP-ZIPTIE-ADMIN') ||
                userInfo.memberOf.includes('APP-OAUTH2-ZIPTIE-READ')) && (
                <StoreDeviceStatuses classes={classes} />
              )}
            {this.state.selectedTab === 'IMAGESOUND PLAYERS' &&
              (userInfo.memberOf.includes('APP-ZIPTIE-ADMIN') ||
                userInfo.memberOf.includes('APP-OAUTH2-ZIPTIE-READ')) && (
                <ImagesoundPlayers classes={classes} />
              )}
          </Card>
        </Grid>
      </div>
    )
  }
}

const mapStateToProps = (state) => {
  return {
    userInfo: state.auth.userInfo,
  }
}

const mapDispatchToProps = {}

export default connect(mapStateToProps, mapDispatchToProps)(DeviceStatuses)
